import React, { ChangeEvent, useMemo } from 'react';
import { Autocomplete, styled, TextField, TextFieldVariants } from '@mui/material';
import { sortBy, uniqBy } from 'lodash';
import { worldCurrencies } from 'utilities';

const StyledAutoComplete = styled(Autocomplete)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export type CurrencyListOption = {
  value: string;
  label: string;
};

type CurrencyListProps = {
  label: string;
  formCurrency?: string;
  handleCurrencyChange?: (event: ChangeEvent<unknown>, option: CurrencyListOption) => void;
  variant?: TextFieldVariants;
};

const CurrencyList = (props: CurrencyListProps) => {
  const { label, formCurrency, handleCurrencyChange, variant = 'standard' } = props;

  const currencies = Object.keys(worldCurrencies).map(currency => ({ value: currency, label: currency }));

  const uniqueCurrencies = uniqBy(currencies, 'label');

  const selectedCurrency = useMemo(
    () => uniqueCurrencies.find(c => c.value === formCurrency),
    [uniqueCurrencies, formCurrency]
  );

  return (
    <StyledAutoComplete
      id={label.toLowerCase().replaceAll(' ', '-')}
      options={sortBy(uniqueCurrencies, 'label')}
      style={{ width: '100%' }}
      autoHighlight
      getOptionLabel={option => option.label}
      onChange={handleCurrencyChange}
      value={selectedCurrency}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          label={label}
          name={label.toLowerCase().replaceAll(' ', '-')}
          variant={variant}
        />
      )}
      disableClearable
    />
  );
};

export default CurrencyList;
